import { createContext } from 'react';

export const SportRuleContext = createContext({
  sportRules: [],
  sportRule: {},
  sports: [],
  weights: [],
  provinces: [],
  ranks: [],
});
